// @ts-strict-ignore
import {Component, Input, output} from "@angular/core";
import {ActivityState, ConnectivityState, Media, MediaType, PlayerMapping} from "@models";
import {EventEmitterService} from "@event-emitter";
import {SimDebriefingService} from "@services";
import {Translations} from "@translations";

@Component({
	selector: "sim-media-card-power-point",
	templateUrl: "./media-card-power-point.component.html",
	styleUrls: ["./media-card-power-point.component.scss"],
	providers: [EventEmitterService],
	standalone: false,
})
export class MediaCardPowerPointComponent {
	T = Translations;

	@Input() media: Media;
	@Input() mediaPlayer: PlayerMapping;
	toggleMedia = output<{
		player: PlayerMapping;
		media: Media;
	}>();

	MediaType = MediaType;
	ConnectivityState = ConnectivityState;
	ActivityState = ActivityState;

	pptxLoaded: boolean;
	pptxLoadingError: boolean;

	constructor(private _simStationDebriefingProxyService: SimDebriefingService) {}

	public async previousPage(mediaId: string): Promise<void> {
		await this._simStationDebriefingProxyService.powerpointNavigateBackward({
			playerId: this.mediaPlayer.id,
			mediaId: mediaId,
			fast: false,
		});
	}

	public async nextPage(mediaId: string): Promise<void> {
		await this._simStationDebriefingProxyService.powerpointNavigateForward({
			playerId: this.mediaPlayer.id,
			mediaId: mediaId,
			fast: false,
		});
	}

	mediaClicked(): void {
		if (this.mediaPlayer?.webSocket?.activityState !== ActivityState.Inactive) {
			this.toggleMedia.emit({
				player: this.mediaPlayer,
				media: this.media,
			});
		}
	}

	isPlayerUnusable(): boolean {
		return (
			!(this.media.id === this.mediaPlayer?.info?.currentMedia?.mediaId && this.mediaPlayer?.info?.currentMedia?.isPlaying) ||
			this.mediaPlayer?.webSocket?.activityState === ActivityState.Inactive
		);
	}

	canNavigate(direction: "backward" | "forward"): boolean {
		const currentPage = this.mediaPlayer?.info?.currentMedia?.currentPosition;
		const totalPages = this.mediaPlayer?.info?.currentMedia?.totalLength;
		return direction === "backward" ? currentPage > 1 : currentPage < totalPages;
	}
}
